/**
 * Veridex Protocol SDK — Avalanche Chain Module
 */

export { AvalancheClient } from './AvalancheClient.js';
export type { AvalancheClientConfig } from './AvalancheClient.js';
